import { styled, Box, ifProp, selectTheme, media } from '@creditas-ui/react';

type SubMenuItemProps = {
  active?: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

const SubMenuItem = styled(Box)<SubMenuItemProps>`
  color: ${ifProp('active', selectTheme('colors.neutral.100'), selectTheme('colors.neutral.60'))};
  font-size: ${selectTheme('fontSizes.4xl')};
  font-weight: ${selectTheme('fontWeight.xs')};
  line-height: ${selectTheme('lineHeight.3xl')};
  margin-bottom: 2px;

  &:hover {
    color: ${selectTheme('colors.neutral.100')};
  }

  ${media.up('5xl')} {
    font-size: ${selectTheme('fontSizes.sm')};
    font-weight: ${selectTheme('fontWeight.sm')};
    line-height: ${selectTheme('lineHeight.sm')};
    margin-bottom: 0;
  }
`;

export { SubMenuItem };
